import { createTracker } from 'usage-tracker';
import { toError } from 'utility-belt/toError';
import Raven from 'raven-js';
import { isQA } from 'utility-belt/urls';
import { ContractActions } from './features/actions/types';
const DEFAULT_TRACKER_PROPS = {
  standalone: true,
  properties: {
    namespace: 'commerce-contract'
  },
  onError: err => {
    const error = toError(err);
    Raven.captureMessage('commerce-contract-lib tracker event error', {
      stacktrace: true,
      extra: {
        message: error.message
      }
    });
  }
};
export const tracker = createTracker(DEFAULT_TRACKER_PROPS);
export function interaction(type) {
  return value => {
    var _value, _value$toString;
    if (typeof value === 'object') {
      value = undefined;
    }
    value = (_value = value) === null || _value === void 0 || (_value$toString = _value.toString) === null || _value$toString === void 0 ? void 0 : _value$toString.call(_value);
    if (isQA()) {
      /* eslint-disable-next-line no-console */
      console.info(value ? `interaction = "${type}", value = "${value}"` : `interaction = "${type}"`);
    }
    tracker.track('Commerce Contract', 'Actions Clicked', {
      type,
      value
    });
  };
}
const contractActions = {
  [ContractActions.VIEW_CHANGE_QUOTE]: {
    open: 'click:actions/viewChange',
    submit: 'click:actions/viewChange/submit',
    cancel: 'click:actions/viewChange/cancel'
  },
  [ContractActions.CREATE_CHANGE_QUOTE]: {
    open: 'click:actions/change',
    submit: 'click:actions/change/submit',
    cancel: 'click:actions/change/cancel'
  },
  [ContractActions.CANCEL_CHANGE_QUOTE]: {
    open: 'click:actions/cancelChangeQuote',
    submit: 'click:actions/cancelChangeQuote/submit',
    cancel: 'click:actions/cancelChangeQuote/cancel'
  },
  [ContractActions.VIEW_RENEWAL_QUOTE]: {
    open: 'click:actions/viewRenewal',
    submit: 'click:actions/viewRenewal/submit',
    cancel: 'click:actions/viewRenewal/cancel'
  },
  [ContractActions.CREATE_RENEWAL_QUOTE]: {
    open: 'click:actions/renewal',
    submit: 'click:actions/renewal/submit',
    cancel: 'click:actions/renewal/cancel'
  },
  [ContractActions.CANCEL_RENEWAL_QUOTE]: {
    open: 'click:actions/cancelRenewalQuote',
    submit: 'click:actions/cancelRenewalQuote/submit',
    cancel: 'click:actions/cancelRenewalQuote/cancel'
  },
  [ContractActions.RESCHEDULE_TERMINATION]: {
    open: 'click:actions/rescheduleTermination',
    submit: 'click:actions/rescheduleTermination/submit',
    cancel: 'click:actions/rescheduleTermination/cancel'
  },
  [ContractActions.CANCEL_TERMINATION]: {
    open: 'click:actions/cancelTermination',
    submit: 'click:actions/cancelTermination/submit',
    cancel: 'click:actions/cancelTermination/cancel'
  },
  [ContractActions.TERMINATE]: {
    open: 'click:actions/terminate',
    submit: 'click:actions/terminate/submit',
    cancel: 'click:actions/terminate/cancel'
  },
  [ContractActions.UPDATE_PAYMENT_METHOD]: {
    open: 'click:actions/updatePaymentMethod',
    submit: 'click:actions/updatePaymentMethod/submit',
    cancel: 'click:actions/updatePaymentMethod/cancel'
  },
  [ContractActions.DELETE_CONTRACT]: {
    open: 'click:actions/delete',
    submit: 'click:actions/delete/submit',
    cancel: 'click:actions/delete/cancel'
  }
};
export const staticEvents = Object.freeze({
  lineItems: {
    editLineItems: 'click:lineItems/editLineItems'
  },
  permissions: {
    missingReadScope: 'permissions:missingContractReadScope',
    missingWriteScope: 'permissions:missingContractWriteScope'
  }
});
function toInteractions(entry) {
  if (typeof entry === 'string') {
    return interaction(entry);
  }
  return Object.fromEntries(Object.entries(entry).map(([key, value]) => [key, toInteractions(value)]));
}
export const events = Object.freeze(Object.assign({}, toInteractions(staticEvents), toInteractions(contractActions)));